module.exports = __webpack_public_path__ + "static/img/2灯泡.9150779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2灯泡.png
// module id = x8lB
// module chunks = 16